import type { EntityTable, IDType } from 'dexie'
import type { RegistroBase } from './tipos'

// Politica UNICA para toda tela de detalhe/edicao que abre um registro pelo
// `id` da URL: um registro apagado (apagado_em preenchido) e tratado como se
// nao existisse. Sem isto, uma aba antiga, o historico do navegador ou duas
// abas/aparelhos abrem a tela de edicao de um registro que ja nao existe em
// lugar nenhum -- o que a pessoa digitar entra na fila de sincronizacao contra
// um registro apagado, perda silenciosa do que ela escreveu.
export async function buscarVivo<T extends RegistroBase>(
  tabela: EntityTable<T, 'id'>,
  id: string | undefined,
): Promise<T | undefined> {
  if (!id) return undefined
  // O `id` das linhas deste app e sempre string (RegistroBase.id) -- o cast
  // so contorna o Dexie nao provar isso para um T generico, IDType<T,'id'>
  // ainda resolve para T['id'] em tempo de execucao.
  const registro = await tabela.get(id as IDType<T, 'id'>)
  return registro && registro.apagado_em === null ? registro : undefined
}
